var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"corner",class:'lang-'+_vm.lang,attrs:{"title":_vm.labels['translate']},on:{"click":_vm.switchLanguage}})}
var staticRenderFns = []

export { render, staticRenderFns }